import React from 'react';

import { QuestionCurrencyDefaultProps, QuestionCurrencyPropTypes } from 'src/components/JobDatasheet/propTypes';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionCurrency = ({
  isRectifiedQuestion,
  onChange,
  question,
  value,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'currencyId';
  const { currencySettings: { currencyItems } } = question;

  const getReturnObject = val => {
    const returnObject = {
      ...value,
      type: 'currency'
    };

    returnObject[selectedValueKey] = val;

    return returnObject;
  };

  return (
    <s.CurrencyWrapper>
      {(currencyItems || []).map(currency => (
        <s.Currency
          key={currency.id}
          active={(value || {})[selectedValueKey] === currency.id}
          onClick={e => {
            e.stopPropagation();

            onChange(getReturnObject(currency.id));
          }}
        >
          {currency.symbol}
        </s.Currency>
      ))}
    </s.CurrencyWrapper>
  );
};

QuestionCurrency.propTypes = QuestionCurrencyPropTypes;
QuestionCurrency.defaultProps = QuestionCurrencyDefaultProps;
